import React from 'react';

interface IPayoutArrowup{
  color?:string;
}
const PayoutArrowup = ({ color }:IPayoutArrowup) => (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 0L8.39711 6.75H0.602886L4.5 0Z" fill={color || '#12B76A'} />
  </svg>

);

export default PayoutArrowup;
